// src/admin/modules/AdminNavs.js
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import useAuth from '../../components/hooks/hooks-e-commerce/useAuth';
import LogoSideBar from '../../shop/components/images/navbar/LogoW250.png';
import './admin-navs.scss';

export function AdminSideBar() {
    return (
        <div className="admin-sidebar">
            <div className="admin-logo">
                <img src={LogoSideBar} alt="logo of the site" />
            </div>
            <nav className="admin-nav">
                <NavLink to="/admin" className={({ isActive }) => isActive ? 'active' : ''}>
                    📊 Dashboard
                </NavLink>
                <NavLink to="/admin/orders" className={({ isActive }) => isActive ? 'active' : ''}>
                    📦 Ordini
                </NavLink>
                <NavLink to="/admin/users" className={({ isActive }) => isActive ? 'active' : ''}>
                    👥 Utenti
                </NavLink>
                <NavLink to="/admin/stats" className={({ isActive }) => isActive ? 'active' : ''}>
                    📈 Statistiche
                </NavLink>
                <NavLink to="/admin/coupons" className={({ isActive }) => isActive ? 'active' : ''}>
                    🏷️ Coupons & Sconti
                </NavLink>
                <NavLink to="/admin/shipping" className={({ isActive }) => isActive ? 'active' : ''}>
                    🚚 Tracking spedizioni
                </NavLink>
                <NavLink to="/admin/newsletter" className={({ isActive }) => isActive ? 'active' : ''}>
                    📧 Newsletter
                </NavLink>
                <NavLink to="/admin/suppliers" className={({ isActive }) => isActive ? 'active' : ''}>
                    🏭 Fornitore
                </NavLink>
            </nav>
        </div>
    );
}

export function AdminNavBar() {
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="admin-header">
            <div className="header-title">
                <h1>
                    Benvenuto, <span>{user?.nome_utente || 'Admin'}</span>!
                </h1>
                <div className="admin-badge">
                    👑 Amministratore
                </div>
            </div>
            <div className="admin-actions">
                <button className="logout-btn" onClick={() => navigate('/')}>
                    ← Torna al sito
                </button>
            </div>
        </div>
    );
}
